import { createBucketClient } from '@cosmicjs/sdk';
import {
  APP_CONFIG_LOADING,
  APP_CONFIG_SUCCESS,
  APP_CONFIG_ERROR,
} from './actionTypes';

const cosmic = createBucketClient({
  bucketSlug: 'redflag-ai-production',
  readKey: process.env.COSMIC_API_READ_KEY,
});

const fetchConfig = async (param, isMultiple = false) => {
  let config = null;
  const data = await cosmic.objects.find({ type: param }).props(['slug,title,metadata']);
  if (data && !isMultiple) {
    config = data.objects[0]?.metadata?.config;
  } else if (data && isMultiple) {
    config = data.objects;
  }
  return config;
};

/* eslint-disable import/prefer-default-export */
export const fetchAppConfigs = () => async (dispatch) => {
  dispatch({ type: APP_CONFIG_LOADING });
  try {
    const themeConfig = await fetchConfig('auth-pages-v4');
    const customReportsConfig = await fetchConfig('embed-settings', true);
    const cyclopsConfig = await fetchConfig('cyclops-api', true);
    dispatch({
      type: APP_CONFIG_SUCCESS,
      payload: { themeConfig, customReportsConfig, cyclopsConfig },
    });
  } catch (error) {
    dispatch({ type: APP_CONFIG_ERROR, error });
  }
};
